import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/SEO';
import HeroSection from './components/HeroSection';
import TrustStrip from './components/TrustStrip';
import ProductCategories from './components/ProductCategories';
import FeaturedProducts from './components/FeaturedProducts';
import BenefitsSection from './components/BenefitsSection';
import WhyChooseUs from './components/WhyChooseUs';
import GallerySection from './components/GallerySection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const homeJsonLd = [
  {
    '@type': 'Organization',
    name: 'Hamva Pharmaceuticals',
    alternateName: 'Hamva Pharma',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/f20d0faf8761bd92da69a0386cf62d57.png',
    description: 'Hamva Pharmaceuticals delivers advanced veterinary medicines, growth boosters, and nutritional supplements trusted by farmers across Pakistan.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '8km Lahore GT Road Rawat',
      addressLocality: 'Rawalpindi',
      addressCountry: 'PK',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+92-300-7321011',
      contactType: 'customer service',
      availableLanguage: ['en', 'ur'],
    },
    sameAs: [
      'https://wa.me/923007321011',
    ],
  },
  {
    '@type': 'WebSite',
    name: 'Hamva Pharmaceuticals',
    url: siteUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/products`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@type': 'LocalBusiness',
    name: 'Hamva Pharmaceuticals',
    image: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/f20d0faf8761bd92da69a0386cf62d57.png',
    '@id': siteUrl,
    url: siteUrl,
    telephone: '+92-300-7321011',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '8km Lahore GT Road Rawat',
      addressLocality: 'Rawalpindi',
      addressCountry: 'PK',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 33.5651,
      longitude: 73.0169,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '09:00',
        closes: '18:00',
      },
    ],
    priceRange: '$$',
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-dark font-inter text-white">
      <SEO
        title="Hamva Pharmaceuticals | Veterinary &amp; Animal Health Solutions Pakistan"
        description="Boost milk and meat production with high-performance veterinary solutions trusted by farmers across Pakistan. Explore growth boosters, milk enhancers, and animal health supplements."
        keywords="veterinary medicines Pakistan, animal health supplements, livestock growth boosters, milk production enhancer, hamva pharmaceuticals"
        ogTitle="Hamva Pharmaceuticals | Elite Animal Health Solutions"
        ogDescription="High-performance veterinary products for livestock. Trusted by farmers and distributors across Pakistan."
        ogImage="https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/f20d0faf8761bd92da69a0386cf62d57.png"
        ogType="website"
        canonical={siteUrl}
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustStrip />
        <ProductCategories />
        <FeaturedProducts />
        <BenefitsSection />
        <WhyChooseUs />
        <GallerySection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
